import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04bd09e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["headers"]
const _hoisted_10 = ["data-cy-name"]
const _hoisted_11 = ["headers"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "ecv-version-text"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "ecv-year-text"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  key: 3,
  class: "future-text"
}
const _hoisted_19 = {
  key: 4,
  class: "future-text"
}
const _hoisted_20 = ["headers"]
const _hoisted_21 = ["headers"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["data-js-target"]
const _hoisted_24 = {
  class: "icon-svg",
  style: {"float":"right"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  height: "19px",
  width: "16px",
  "xlink:href": "#location-on"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["data-js-target"]
const _hoisted_28 = {
  class: "icon-svg",
  style: {"float":"right"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  height: "19px",
  width: "16px",
  "xlink:href": "#location-on"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["id"]
const _hoisted_32 = { style: {"padding-left":"1rem"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))
const _hoisted_34 = { style: {"text-align":"left","padding-left":"1rem"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = ["id"]
const _hoisted_38 = { style: {"padding-left":"1rem"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))
const _hoisted_40 = {
  key: 0,
  style: {"text-align":"left","padding-left":"1rem"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { key: 3 }
const _hoisted_46 = ["headers"]
const _hoisted_47 = ["headers"]
const _hoisted_48 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_49 = ["data-js-target"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["id"]
const _hoisted_53 = {
  key: 0,
  class: "overflow-list"
}
const _hoisted_54 = { style: {"padding-top":"0"} }
const _hoisted_55 = ["id", "onClick"]
const _hoisted_56 = ["id"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#refresh" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_60 = {
  key: 1,
  class: "edit-button"
}
const _hoisted_61 = { class: "disabled no-pointer-events" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3 disabled",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#content-copy" })
], -1))
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_67 = {
  key: 0,
  class: "unlock-button"
}
const _hoisted_68 = { class: "disabled pointer-events-none" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3 disabled",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#lock" })
], -1))
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#lock" })
], -1))
const _hoisted_72 = {
  key: 1,
  class: "overflow-list"
}
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["id"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#refresh" }, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = {
  key: 1,
  class: "ecv-update-disabled"
}
const _hoisted_80 = ["id"]
const _hoisted_81 = { class: "disabled no-pointer-events" }
const _hoisted_82 = ["id"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#refresh" }, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { style: {"padding":"8px 16px","width":"100%","text-align":"right"} }
const _hoisted_86 = { class: "disabled" }
const _hoisted_87 = {
  "aria-hidden": "true",
  class: "icon-svg ml-3 disabled",
  focusable: "false",
  style: {"float":"none"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" }, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#content-copy" })
], -1))
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#visibility" })
], -1))
const _hoisted_94 = {
  key: 0,
  class: "unlock-button"
}
const _hoisted_95 = { class: "disabled no-pointer-events" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3 disabled",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#lock-open" })
], -1))
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#lock-open" })
], -1))
const _hoisted_99 = {
  key: 2,
  class: "overflow-list"
}
const _hoisted_100 = ["onClick"]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#visibility" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", {
      id: _ctx.id,
      "aria-label": "oversigt over beregninger",
      class: "table w-percent-100"
    }, [
      _createElementVNode("thead", null, [
        (_ctx.tableHeaders)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  id: `table-header-${index}-${_ctx.id}`,
                  key: tableHeader.sortKey,
                  class: "clickable",
                  scope: "col",
                  onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                }, [
                  _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                  (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                    _createElementVNode("path", {
                      fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDir === 'asc' ? 'white' : '',
                      "clip-rule": "evenodd",
                      d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                      "fill-rule": "evenodd",
                      stroke: "white"
                    }, null, 8, _hoisted_5),
                    _createElementVNode("path", {
                      fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDir === 'desc' ? 'white' : '',
                      "clip-rule": "evenodd",
                      d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                      "fill-rule": "evenodd",
                      stroke: "white"
                    }, null, 8, _hoisted_6)
                  ]))
                ], 8, _hoisted_3))
              }), 128)),
              _hoisted_7
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.sortedCalculations.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              _createElementVNode("td", {
                headers: _ctx.getRowDataHeaderDefinition(_ctx.id),
                class: "table-no-content",
                colspan: "5"
              }, [
                _createVNode(_component_SimpleText, { "text-key": "missing-calculations-in-list.message" })
              ], 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCalculations, (calculation) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: calculation.id,
            "data-cy-name": calculation.calculationPurpose.name
          }, [
            (calculation.calculationPurpose)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 0,
                  headers: `table-header-0-${_ctx.id}`,
                  "data-title": "Navn",
                  style: {"width":"35%"}
                }, [
                  _createTextVNode(_toDisplayString(calculation.calculationPurpose.name) + " ", 1),
                  (_ctx.hasExtraInfoChange(calculation))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(_ctx.extraInfoChange(calculation)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasExtraInfoEMCVersionUpdate(calculation))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(_toDisplayString(_ctx.extraInfoEMCVersionUpdate(calculation)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasExtraInfoECYear(calculation))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(_ctx.extraInfoECYear(calculation)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isInFutureCalculation(calculation))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_18, " " + _toDisplayString(_ctx.extraInfoFutureCalculation(calculation)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isUsedInComparison(calculation))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_19, " " + _toDisplayString(_ctx.extraInfoComparison(calculation)), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_11))
              : _createCommentVNode("", true),
            (calculation.calculationPurpose)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 1,
                  headers: `table-header-1-${_ctx.id}`,
                  "data-title": "Formål",
                  style: {"width":"20%"}
                }, _toDisplayString(_ctx.mapPurpose(calculation.calculationPurpose.purpose)), 9, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("td", {
              headers: `table-header-2-${_ctx.id}`,
              "data-title": "Lokation",
              style: {"width":"25%"}
            }, [
              (calculation.companyInformation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculationLocations(calculation), (value, name) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: name,
                        class: "overflow-menu overflow-menu--open-left w-percent-100"
                      }, [
                        (calculation.companyInformation.country === 'DK')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              "data-js-target": `calculation-${calculation.id}-${name}-overflow`,
                              "aria-expanded": "false",
                              "aria-haspopup": "true",
                              class: "button-overflow-menu js-dropdown w-percent-100 location-button"
                            }, [
                              _createTextVNode(_toDisplayString(name ? name : 'Ukendt'), 1),
                              _createElementVNode("span", null, ", " + _toDisplayString(_ctx.getCountryName(calculation.companyInformation.country)), 1),
                              (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_26))
                            ], 8, _hoisted_23))
                          : (value[0].address.calculationActive)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                "data-js-target": `calculation-${calculation.id}-${name}-overflow`,
                                "aria-expanded": "false",
                                "aria-haspopup": "true",
                                class: "button-overflow-menu js-dropdown w-percent-100 location-button"
                              }, [
                                _createTextVNode(_toDisplayString(name ? name : 'Ukendt'), 1),
                                _createElementVNode("span", null, ", " + _toDisplayString(_ctx.getCountryName(calculation.companyInformation.country)), 1),
                                (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                              ], 8, _hoisted_27))
                            : _createCommentVNode("", true),
                        (calculation.companyInformation.country === 'DK')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              id: `calculation-${calculation.id}-${name}-overflow`,
                              class: _normalizeClass([`calculation-${name}-overflow`, "overflow-menu-inner"]),
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("strong", _hoisted_32, [
                                _createTextVNode(_toDisplayString(name ? name : 'Ukendt'), 1),
                                _createElementVNode("span", null, ", " + _toDisplayString(_ctx.getCountryName(calculation.companyInformation.country)), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (productionUnit) => {
                                return (_openBlock(), _createElementBlock("ul", {
                                  key: productionUnit.pNumber,
                                  class: "overflow-list"
                                }, [
                                  _hoisted_33,
                                  _createElementVNode("li", _hoisted_34, [
                                    _createElementVNode("strong", null, _toDisplayString(`P-${productionUnit.pNumber}:`), 1),
                                    _hoisted_35,
                                    _createTextVNode(" " + _toDisplayString(`${productionUnit.address.street ? productionUnit.address.street : ''} ${productionUnit.address.houseNumberFrom ? productionUnit.address.houseNumberFrom : ''}`) + ", ", 1),
                                    _hoisted_36,
                                    _createTextVNode(" " + _toDisplayString(`${productionUnit.address.zipCode ? productionUnit.address.zipCode : ''} ${productionUnit.address.city ? productionUnit.address.city : ''}`), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 10, _hoisted_31))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              id: `calculation-${calculation.id}-${name}-overflow`,
                              class: _normalizeClass([`calculation-${name}-overflow`, "overflow-menu-inner"]),
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("strong", _hoisted_38, [
                                _createTextVNode(_toDisplayString(name), 1),
                                _createElementVNode("span", null, ", " + _toDisplayString(_ctx.getCountryName(calculation.companyInformation.country)), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (productionUnit) => {
                                return (_openBlock(), _createElementBlock("ul", {
                                  key: productionUnit.pNumber,
                                  class: "overflow-list"
                                }, [
                                  _hoisted_39,
                                  (productionUnit.address.calculationActive)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                        _createElementVNode("span", null, _toDisplayString(productionUnit.address.street), 1),
                                        _hoisted_41,
                                        (productionUnit.address.placeName)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(productionUnit.address.placeName), 1))
                                          : _createCommentVNode("", true),
                                        (productionUnit.address.placeName)
                                          ? (_openBlock(), _createElementBlock("br", _hoisted_43))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(productionUnit.address.zipCode) + " " + _toDisplayString(productionUnit.address.city), 1),
                                        (productionUnit.address.state)
                                          ? (_openBlock(), _createElementBlock("br", _hoisted_44))
                                          : _createCommentVNode("", true),
                                        (productionUnit.address.state)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(productionUnit.address.state), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 10, _hoisted_37))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_21),
            (calculation.calculationPurpose)
              ? _withDirectives((_openBlock(), _createElementBlock("td", {
                  key: 2,
                  headers: `table-header-3-${_ctx.id}`,
                  "data-title": "Periode",
                  style: {"width":"20%"}
                }, null, 8, _hoisted_46)), [
                  [_directive_dompurify_html, _ctx.formatDates(calculation.calculationPurpose.startDate, calculation.calculationPurpose.endDate)]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("td", {
              headers: `table-header-3-${_ctx.id}`,
              "data-title": "Handlinger",
              class: _normalizeClass(_ctx.isCopy(calculation) || _ctx.isNewECVersion(calculation) ? 'marked-as-copy' : '')
            }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("button", {
                  class: _normalizeClass([`overflow-menu-table`, "button-overflow-menu js-dropdown"]),
                  "data-js-target": `calculation-${calculation.id}-actions-overflow`,
                  "aria-expanded": "false",
                  "aria-haspopup": "true",
                  "aria-label": "handlinger"
                }, _hoisted_51, 8, _hoisted_49),
                _createElementVNode("div", {
                  id: `calculation-${calculation.id}-actions-overflow`,
                  "aria-hidden": "true",
                  class: "overflow-menu-inner"
                }, [
                  (calculation.state === 'draft' || calculation.state === 'duplicated')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_53, [
                        _createElementVNode("li", _hoisted_54, [
                          (_ctx.isNewECVersion(calculation))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                id: `update-ecv-${calculation.id}-button`,
                                class: "update-ecv-button",
                                onClick: ($event: any) => (_ctx.$emit('update-ecv-calculation', calculation))
                              }, [
                                _createVNode(_component_SimpleText, { "text-key": "overview.menu.ecv.update" }),
                                (_openBlock(), _createElementBlock("svg", {
                                  "aria-hidden": "true",
                                  id: `refresh-icon-${calculation.id}`,
                                  class: "icon-svg ml-3",
                                  focusable: "false"
                                }, _hoisted_58, 8, _hoisted_56))
                              ], 8, _hoisted_55))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", null, [
                          (_ctx.isCalculationEcVersionAllowedForRecalculation(calculation))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "edit-button",
                                to: "/calculator/energy-and-processes/electricity",
                                onClick: ($event: any) => (_ctx.$emit('edit-calculation', calculation))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.edit" }),
                                  _hoisted_59
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock("button", _hoisted_60, [
                                _createVNode(_component_Tooltip, {
                                  text: this.updateEcVersionBeforeEditTooltip,
                                  initDkfds: false
                                }, null, 8, ["text"]),
                                _createElementVNode("span", _hoisted_61, [
                                  _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.edit" })
                                ]),
                                _hoisted_62
                              ]))
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "copy-button",
                            onClick: ($event: any) => (_ctx.$emit('copy-calculation', calculation))
                          }, [
                            _createVNode(_component_SimpleText, { "text-key": "shared.copy" }),
                            _hoisted_64
                          ], 8, _hoisted_63)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "delete-button",
                            onClick: ($event: any) => (_ctx.$emit('delete-calculation', calculation))
                          }, [
                            _createVNode(_component_SimpleText, { "text-key": "shared.delete" }),
                            _hoisted_66
                          ], 8, _hoisted_65)
                        ]),
                        _createElementVNode("li", null, [
                          (!calculation.hasCalculationLines)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_67, [
                                _createVNode(_component_Tooltip, {
                                  text: _ctx.getContentfulString('overview.menu.empty-calculation'),
                                  initDkfds: false
                                }, null, 8, ["text"]),
                                _createElementVNode("span", _hoisted_68, [
                                  _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.finish" })
                                ]),
                                _hoisted_69
                              ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "finish-button",
                                onClick: ($event: any) => (_ctx.$emit('complete-calculation', calculation))
                              }, [
                                _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.finish" }),
                                _hoisted_71
                              ], 8, _hoisted_70))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (calculation.state === 'finished' || calculation.state === 'readonly' || calculation.state === 'finished_duplicated')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_72, [
                        _createElementVNode("li", null, [
                          (_ctx.isNewECVersion(calculation))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                (!_ctx.isCalculationForecasted(calculation))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                      _createElementVNode("button", {
                                        id: "update-ecv",
                                        class: "update-ecv-button",
                                        onClick: ($event: any) => (_ctx.$emit('update-ecv-calculation', calculation))
                                      }, [
                                        _createVNode(_component_SimpleText, { "text-key": "overview.menu.ecv.update" }),
                                        (_openBlock(), _createElementBlock("svg", {
                                          "aria-hidden": "true",
                                          id: `refresh-icon-${calculation.id}-finished`,
                                          class: "icon-svg ml-3",
                                          focusable: "false"
                                        }, _hoisted_78, 8, _hoisted_76))
                                      ], 8, _hoisted_75)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                      _createElementVNode("button", {
                                        disabled: "true",
                                        id: `update-ecv-disable-${calculation.id}-button`
                                      }, [
                                        _createVNode(_component_Tooltip, {
                                          text: this.forecastedCannotUpdateEcVersionTooltip,
                                          initDkfds: false
                                        }, null, 8, ["text"]),
                                        _createElementVNode("span", _hoisted_81, [
                                          _createVNode(_component_SimpleText, { "text-key": "overview.menu.ecv.update" }),
                                          (_openBlock(), _createElementBlock("svg", {
                                            "aria-hidden": "true",
                                            id: `refresh-icon-${calculation.id}-disabled`,
                                            class: "icon-svg ml-3",
                                            focusable: "false"
                                          }, _hoisted_84, 8, _hoisted_82))
                                        ])
                                      ], 8, _hoisted_80)
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_Tooltip, {
                              text: this.deleteTooltip,
                              initDkfds: false
                            }, {
                              "text-after": _withCtx(() => [
                                _createElementVNode("span", _hoisted_86, [
                                  _createVNode(_component_SimpleText, { "text-key": "shared.delete" })
                                ]),
                                (_openBlock(), _createElementBlock("svg", _hoisted_87, _hoisted_89))
                              ]),
                              _: 1
                            }, 8, ["text"])
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "copy-button",
                            onClick: ($event: any) => (_ctx.$emit('copy-calculation', calculation))
                          }, [
                            _createVNode(_component_SimpleText, { "text-key": "shared.copy" }),
                            _hoisted_91
                          ], 8, _hoisted_90)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "show-button",
                            onClick: ($event: any) => (_ctx.$emit('show-calculation', calculation))
                          }, [
                            _createVNode(_component_SimpleText, { "text-key": "shared.show" }),
                            _hoisted_93
                          ], 8, _hoisted_92)
                        ]),
                        _createElementVNode("li", null, [
                          (_ctx.isInFutureCalculation(calculation) || _ctx.isUsedInComparison(calculation))
                            ? (_openBlock(), _createElementBlock("button", _hoisted_94, [
                                _createVNode(_component_Tooltip, {
                                  text: _ctx.tooltip,
                                  initDkfds: false
                                }, null, 8, ["text"]),
                                _createElementVNode("span", _hoisted_95, [
                                  _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.unlock" })
                                ]),
                                _hoisted_96
                              ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "unlock-button",
                                onClick: ($event: any) => (_ctx.$emit('reopen-calculation', calculation))
                              }, [
                                _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.unlock" }),
                                _hoisted_98
                              ], 8, _hoisted_97))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (calculation.state === 'forecasted')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_99, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "show-button",
                            onClick: ($event: any) => (_ctx.$emit('show-calculation', calculation))
                          }, [
                            _createVNode(_component_SimpleText, { "text-key": "shared.show" }),
                            _hoisted_101
                          ], 8, _hoisted_100)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_52)
              ])
            ], 10, _hoisted_47)
          ], 8, _hoisted_10))
        }), 128))
      ])
    ], 8, _hoisted_1)
  ]))
}